import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SymbolRegistryEntry {
  id: string;
  symbol: string;
  display_name: string;
  asset_class: string;
  data_provider: string;
  is_active: boolean;
}

export function useSymbolRegistry() {
  return useQuery({
    queryKey: ['symbol-registry'],
    queryFn: async (): Promise<SymbolRegistryEntry[]> => {
      const { data, error } = await supabase
        .from('symbol_registry')
        .select('id, symbol, display_name, asset_class, data_provider, is_active')
        .eq('is_active', true);
      if (error) throw error;
      return (data || []) as SymbolRegistryEntry[];
    },
    staleTime: 300000,
  });
}
